import React from 'react';

// Catches render/lifecycle errors in whatever it wraps so one broken page
// (e.g. a map library throwing deep inside a plugin) doesn't unmount the
// entire app — the sidebar/topbar stay usable and the user can navigate
// away instead of getting a blank screen. Hit twice in one session before
// this existed (both times a Leaflet plugin call threw with no boundary
// above it), hence adding it at the routed-page level in App.jsx.
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('Unhandled error in page:', error, info.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    height: '100%', padding: 40, textAlign: 'center', gap: 12,
                }}>
                    <div style={{ fontSize: 32 }}>⚠</div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--t-white)' }}>Something went wrong on this page</div>
                    <div style={{ fontSize: 12, color: 'rgba(148,168,200,0.7)', maxWidth: 500 }}>
                        {this.state.error.message || String(this.state.error)}
                    </div>
                    <button
                        onClick={() => this.setState({ error: null })}
                        style={{
                            marginTop: 8, padding: '8px 18px', borderRadius: 6, border: '1px solid rgba(58,138,196,0.4)',
                            background: 'rgba(58,138,196,0.12)', color: '#3a8ac4', fontSize: 12, fontWeight: 700, cursor: 'pointer',
                        }}
                    >
                        Try Again
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
